import { render, staticRenderFns } from "./exhibitorInfo.vue?vue&type=template&id=3678f6fd&scoped=true&"
import script from "./exhibitorInfo.vue?vue&type=script&lang=js&"
export * from "./exhibitorInfo.vue?vue&type=script&lang=js&"
import style0 from "./exhibitorInfo.vue?vue&type=style&index=0&id=3678f6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678f6fd",
  null
  
)

export default component.exports